import React from "react";

const RestaurantDetail = ({
  innerWidth,
  openLink,
  onClose,
  restaurant,
  setDestination,
  setDestinationAndClose
}) => {
  const imgUrl =
    restaurant.imageUrl === null
      ? "none"
      : 'url("' + restaurant.imageUrl + '")';

  const showHoursOfOperation =
    restaurant.operationHours[Object.keys(restaurant.operationHours)[0]] !== "";

  if (innerWidth < 768) window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="restaurant-detail">
      <div className="media-top">
        {restaurant.imageUrl === null ? (
          <div />
        ) : (
          <div
            className="restaurant-image"
            style={{ backgroundImage: imgUrl }}
          />
        )}

        <div className="padding-container">
          <div className="restaurant-name">{restaurant.restaurantName}</div>
          <div className="restaurant-address">
            {restaurant.unitNumber !== "" ? restaurant.unitNumber + " - " : ""}
            {restaurant.streetAddress +
              " " +
              restaurant.city +
              ", " +
              restaurant.province +
              ", " +
              restaurant.postalCode}
          </div>
          {innerWidth >= 768 ? (
            <div className="button-group">
              <button
                className="reserve-button yellow-button"
                onClick={() => {
                  restaurant.reservationLink !== null
                    ? openLink(restaurant.reservationLink)
                    : openLink(restaurant.websiteLink);
                }}
              >
                RÉSERVER
              </button>
              <button
                className="directions-button gray-button"
                onClick={() => {
                  // console.log(
                  //   "setDestination==>>",
                  //   setDestination,
                  //   "destt",
                  //   restaurant
                  // );
                  setDestination(restaurant.latitude, restaurant.longitude);
                }}
              >
                ITINÉRAIRE
              </button>
              <button
                className="menu-button gray-button"
                onClick={() => {
                  openLink(restaurant.menuLink);
                }}
              >
                MENU
              </button>
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
      <div className="media-bottom">
        <div className="hours-of-operation">
          {showHoursOfOperation ? (
            <div>
              <ul className="days-list">
                {Object.keys(restaurant.operationHours).map(function(key) {
                  return <li key={key}>{key}</li>;
                })}
              </ul>
              <ul className="hours-list">
                {Object.keys(restaurant.operationHours).map(function(key) {
                  return <li key={key}>{restaurant.operationHours[key]}</li>;
                })}
              </ul>
            </div>
          ) : (
            <div className="operation-status">
              <div className="status">FERMÉ TEMPORAIREMENT</div>
              {innerWidth >= 768 ? (
                <div className="message">
                  Veuillez consulter les horaires
                  <br />
                  d’ouverture mis à jour.
                </div>
              ) : (
                <div className="message">
                  Veuillez consulter les horaires d’ouverture mis à jour.
                </div>
              )}
            </div>
          )}
        </div>
        {innerWidth < 768 ? (
          <div className="button-group">
            <button
              className="reserve-button yellow-button"
              onClick={() => {
                restaurant.reservationLink !== null
                  ? openLink(restaurant.reservationLink)
                  : openLink(restaurant.websiteLink);
              }}
            >
              RÉSERVER
            </button>
            <button
              className="directions-button gray-button"
              onClick={() => {
                setDestinationAndClose(
                  restaurant.latitude,
                  restaurant.longitude
                );
              }}
            >
              ITINÉRAIRE
            </button>
            <button
              className="menu-button gray-button"
              onClick={() => {
                openLink(restaurant.menuLink);
              }}
            >
              MENU
            </button>
          </div>
        ) : (
          <div />
        )}
        <div className="beer-deal">
          <img src="" />
        </div>
      </div>
    </div>
  );
};

export default RestaurantDetail;
